export const sliderConfigs = {
	home: {
		titleKey: 'home_slider',
		listPath: '/home-slider-list',
		api: '/homeSliderBanners',
		idKey: 'homesliderbanner_id',
		imageKey: 'homesliderbanner_image',
		linkKey: 'homesliderbanner_link',
		titleField: 'homesliderbanner_title',
		listKey: 'homesliderbanners',
		countKey: 'all_homesliderbanners',
		itemKey: 'homesliderbanner',
		imageTip: '1577*887',
	},
	dashboard: {
		titleKey: 'dashboard_slider',
		listPath: '/dashboard-slider-list',
		api: '/dashboardSliderBanners',
		idKey: 'dashboardsliderbanner_id',
		imageKey: 'dashboardsliderbanner_image',
		linkKey: 'dashboardsliderbanner_link',
		titleField: 'dashboardsliderbanner_title',
		listKey: 'dashboardsliderbanners',
		countKey: 'all_dashboardsliderbanners',
		itemKey: 'dashboardsliderbanner',
		imageTip: '1500*1302',
	},
};
